<script setup lang="ts">
import { computed } from 'vue'
import { format } from 'date-fns'
import { enUS } from 'date-fns/locale/en-US'
import { formatDistanceToNow } from 'date-fns/formatDistanceToNow'
import { mdiAlertOutline, mdiCircleMedium } from '@mdi/js'
import { useAppStore } from '@/modules/app/stores/app.store'

import BadgeMenu from '@/shared/components/badge/BadgeMenu.vue'
import SvgIcon from '@/shared/components/icon/SvgIcon.vue'

const appStore = useAppStore()

const isUnRead = computed(() => appStore.alerts.some((alert) => alert.isUnread))
</script>

<template>
  <BadgeMenu
    v-if="appStore.alerts.length > 0"
    :badge="isUnRead"
    :title="$t('glossary.notification', 2)"
    :icon="mdiAlertOutline"
    class="fill-warning"
  >
    <div v-for="(alert, index) in appStore.alerts" :key="index">
      <div class="bg-black">
        <div class="text-sm text-gray-300 border-b border-gray-800 p-2">
          {{ $t(alert.title) }}
        </div>
        <div
          class="flex items-center cursor-default truncate p-2"
          @mouseover="alert.isUnread = false"
        >
          <SvgIcon :path="alert.icon" class="fill-gray-300 h-12 w-12" />
          <div class="ms-1.5 w-full">
            <div class="flex justify-between items-center text-gray-300">
              <div>
                <div v-if="alert.from && alert.to" class="font-light text-sm">
                  {{ $t('glossary.plannedDowntime') }}
                  <span class="font-medium lowercase">
                    {{ $t('common.from') }}
                    <span>{{ format(alert.from, 'p') }}</span>
                    {{ $t('common.to') }}
                    <span>{{ format(alert.to, 'p') }}</span>
                  </span>
                </div>
                <div v-if="alert.from" class="text-xs text-gray-500">
                  {{
                    $t('message.timeRemaining', {
                      remaining: formatDistanceToNow(alert.from, { locale: enUS }),
                    })
                  }}
                </div>
              </div>
              <div class="flex justify-between items-center">
                <SvgIcon
                  :path="mdiCircleMedium"
                  class="h-5 w-5"
                  :class="alert.isUnread ? 'fill-error' : 'fill-transparent'"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </BadgeMenu>
</template>
